if (!customElements.get('tp-product-card-media')) {
  customElements.define('tp-product-card-media', class extends HTMLElement {
    connectedCallback() {
      this.updateImage = () => {
        const image = this.querySelector('[data-tp-secondary-image]');
        this.toggleAttribute('data-secondary-ready', Boolean(image?.complete && image.naturalWidth > 0));
      };
      this.addEventListener('load', this.updateImage, true);
      this.addEventListener('error', this.updateImage, true);
      this.updateImage();
    }

    disconnectedCallback() {
      this.removeEventListener('load', this.updateImage, true);
      this.removeEventListener('error', this.updateImage, true);
    }
  });
}

